import React, { useRef, useState } from 'react';
import "./form.css";

const Form = () => {
    const form = useRef();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const sendEmail = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("/sendEmail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    to: "contact@rockycoastlabs.com",
                    from_name: name,
                    from_email: email,
                    subject: subject,
                    message: message
                })
            });
            if (response.ok) {
                setName('');
                setEmail('');
                setSubject('');
                setMessage('');
                alert("Email sent");
            } else {
                alert("Failed to send email");
            }
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Error sending email");
        }
    };

    return (
        <form ref={form} className="contact-form-container" onSubmit={sendEmail} id="contact-form">
            <div class="form__div">
                <input name="from_name" type="text" class="form__input" placeholder=" " value={name} onChange={(e) => setName(e.target.value)} />
                <label class="form__label">Name</label>
            </div>
            <div class="form__div">
                <input name="from_email" type="email" class="form__input" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} />
                <label class="form__label">Email</label>
            </div>
            <div class="form__div">
                <input name="subject" type="textarea" class="form__input" placeholder=" " value={subject} onChange={(e) => setSubject(e.target.value)} />
                <label class="form__label">Subject</label>
            </div>
            <div class="form__div">
                <textarea name="message" type="text" class="form__input" placeholder=" " value={message} onChange={(e) => setMessage(e.target.value)} />
                <label class="form__label">Message</label>
            </div>
            <button class="submit-btn" type="submit">Submit</button>
        </form>

    )
};

export default Form
